export default function toGermanDate(date) {
 
        date = date.toString().split('T');
        date = date[0].split('-');
        date = date[2] + '.' + date[1] + '.' + date[0];              
        return date   
  
}
